import Typical_plan_3_10 from '../assets/images/Elysium_Tower/FloorPlan/Typical_plan_3-10.jpg'
import Typical_plan_11_20 from '../assets/images/Elysium_Tower/FloorPlan/Typical_plan_11-20.jpg'
import Unit01 from '../assets/images/Elysium_Tower/FloorPlan/Unit_01.jpg'
import Unit01_500 from '../assets/images/Elysium_Tower/FloorPlan/Unit_01_500.jpg'
import Unit02 from '../assets/images/Elysium_Tower/FloorPlan/Unit_02.jpg'
import Unit02_530 from '../assets/images/Elysium_Tower/FloorPlan/Unit_02_530.jpg'
import Unit03 from '../assets/images/Elysium_Tower/FloorPlan/Unit_03.jpg'
import Unit04 from '../assets/images/Elysium_Tower/FloorPlan/Unit_04.jpg'
import backIcon from "../assets/images/back_icon.png";

import '../assets/css/floorplan.css';
import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap'

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";


const FloorPlanElysiumTower = () => {
    const [isZoomed, setIsZoomed] = useState(false);

    const [activeFilterIndex, setActiveFilterIndex] = useState(0);
    const [imageSrc, setImageSrc] = useState(Typical_plan_3_10);


    const [showPlan, setShowPlan] = useState(false);
    const [isTypicalPlan, setIsTypicalPlan] = useState(false)

    const [openFlat, setOpenFlat] = useState("");
    const [showIframe, setShowIframe] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const [scale, setScale] = useState(1);
    const transformRef = useRef(null);

    const changeFloorPlan = (floorPlan, index) => {
        setActiveFilterIndex(index);
        setImageSrc(floorPlan);
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const img = new Image();
        img.src = imageSrc;

        img.onload = () => {
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;

            const widthScale = screenWidth / img.naturalWidth;
            const heightScale = screenHeight / img.naturalHeight;

            const newScale = Math.min(widthScale, heightScale);

            if (transformRef.current) {
                transformRef.current.resetTransform();
                transformRef.current.centerView(1, 200);
            }
        };
    }, [imageSrc]);

    const getInitialScale = () => {
        if (!isMobile) return 1;
        console.log("dfjihds", imageSrc);
        if (imageSrc === Typical_plan_3_10) return 0.08;
        if (imageSrc === Typical_plan_11_20) return 0.08;

        // default for other images
        return 0.2;
    };

    return (
        <div className="courtyard elysium_tower floorplan_container">
            <div className="w-100 d-flex justify-content-sm-between h-100">
                <div className="left_side_container grey-bg">
                    <TransformWrapper
                        // key={imageSrc} // IMPORTANT: forces re-render when image changes
                        // initialScale={getInitialScale()}
                        // // initialScale={isMobile ? 0.08 : 1}
                        // disablePadding={true}
                        // centerOnInit={true}
                        // wheel={{ step: 0.05 }}
                        // doubleClick={{ mode: "zoomIn" }}
                        // minScale={0.08}
                        ref={transformRef}
                        minScale={0.2}
                        maxScale={4}
                        centerOnInit
                        limitToBounds
                        doubleClick={{ mode: "zoomIn" }}
                    >
                        <TransformComponent
                            // wrapperStyle={{ width: "100vw", height: "100vh", height: "100dvh" }}
                            wrapperStyle={{
                                width: "100%",
                                height: "100dvh",
                                touchAction: "none",
                                overflow: "hidden"
                            }}
                        >
                            <img alt="floor_plan_image" src={imageSrc} style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                userSelect: "none",
                                WebkitUserDrag: "none"
                            }} className={`zoomable-image ${isZoomed ? "zoomed" : ""}`} onClick={() => setIsZoomed(!isZoomed)} />
                        </TransformComponent>
                    </TransformWrapper>
                    {
                        activeFilterIndex !== 0 && activeFilterIndex !== 1 &&
                        <div className='view-web-vr center'><button className='view-web-vr-btn' onClick={() => { setShowPlan(true); }}>Explore WebVR</button> </div>
                    }
                </div>
                <div className="right_side_container">
                    <div className='floor_plan_button-conainer'>
                        <button className="floor_plan_lable">Floor Plans</button>
                        <button onClick={() => { changeFloorPlan(Typical_plan_3_10, 0); }} className={`${activeFilterIndex === 0 ? 'active' : ''} `}>Typical plan 1 (3rd-10th floor)</button>
                        <button onClick={() => { changeFloorPlan(Typical_plan_11_20, 1) }} className={`${activeFilterIndex === 1 ? 'active' : ''} `}>Typical plan 2 (11th-22nd floor)</button>
                        <button onClick={() => { changeFloorPlan(Unit01, 2); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Elysium_Tower/elysium_tower_2bhk_flat-01_450sqft/index.html"); }} className={`${activeFilterIndex === 2 ? 'active' : ''} `}>Flat no 1</button>
                        <button onClick={() => { changeFloorPlan(Unit02, 6); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Elysium_Tower/elysium_tower_2bhk_flat-02_500sqft/index.html") }} className={`${activeFilterIndex === 6 ? 'active' : ''} `}>Flat no 2</button>
                        <button onClick={() => { changeFloorPlan(Unit01_500, 5); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Elysium_Tower/elysium_tower_2bhk_flat-01_500sqft/index.html") }} className={`${activeFilterIndex === 5 ? 'active' : ''} `}>Flat no 1 (balcony)</button>
                        <button onClick={() => { changeFloorPlan(Unit02_530, 7); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Elysium_Tower/elysium_tower_2bhk_flat-02_530stft/index.html"); }} className={`${activeFilterIndex === 7 ? 'active' : ''} `}>Flat no 2 (balcony)</button>
                        <button onClick={() => { changeFloorPlan(Unit03, 3); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Elysium_Tower/elysium_tower_2bhk_flat-03_570sqft/index.html") }} className={`${activeFilterIndex === 3 ? 'active' : ''} `}>Flat no 3</button>
                        <button onClick={() => { changeFloorPlan(Unit04, 4); setOpenFlat("https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Elysium_Tower/elysium_tower_2bhk_flat-04_510sqft/index.html") }} className={`${activeFilterIndex === 4 ? 'active' : ''} `}>Flat no 4</button>
                    </div>

                </div>
            </div>

            <Modal
                centered
                show={showPlan}
                onHide={() => setShowPlan(false)}
                aria-labelledby="example-custom-modal-styling-title"
                className="inventory_floor_plan_dialog"
            >
                <Modal.Body>
                    <button className="back_btn" onClick={() => { if (showIframe) { setShowIframe(false); } else { setShowPlan(false) } }}>
                        <img src={backIcon} alt="back icon" className="backIcon" />
                    </button>
                    <iframe src={openFlat} height="100%" width="100%" className="flats_iframe flats_iframe_elysium" />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default FloorPlanElysiumTower;